module.exports = __webpack_public_path__ + "static/media/site_resources_header_mobile.efe966d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/siteResources/assets/site_resources_header_mobile.jpeg
// module id = 1132
// module chunks = 1